<template lang="html">
  <v-menu
    v-model="isMenuOpen"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
    max-width="290px"
    offset-y
  >
    <template #activator="{ on }">
      <Textfield
        v-bind="$attrs"
        :value="localValue"
        readonly
        v-on="on"
        :rules="rules"
        prepend-inner-icon="mdi-clock-outline"
      />
    </template>
    <v-time-picker
      v-if="isMenuOpen"
      v-model="localValue"
      scrollable
      format="24hr"
      color="primary"
      :allowed-minutes="n => n % allowedMinutes === 0"
      :min="min"
      :max="max"
      @click:minute="handleChange"
    />
  </v-menu>
</template>

<script>
import { debounce } from 'lodash';
import Textfield from './Textfield.vue';

export default {
  components: {
    Textfield,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
    allowedMinutes: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleChange: debounce(function() {
      this.isMenuOpen = false;
    }, 500),
  },
};
</script>
<style lang="css" scoped>
.v-input__slot {
  padding-right: 0px !important;
  padding-left: 8px !important;
}
</style>